// Template
// import {document} from "ionicons/icons";

require('./dashforge/dashforge');
const axios = require('axios').default;
const SimpleMDE = require('simplemde');

// Components
require('datatables.net');
require('datatables.net-bs4');
const Swal = require('sweetalert2');
require('select2');

function promptDeleteAccount(user, row) {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.value) {
            axios.post('delete-account', {
                    'user': user,
                }
            )
                .then(function (response) {
                    row.remove().draw();

                    Swal.fire(
                        'Deleted!',
                        'The account has been deleted.',
                        'success'
                    );
                    // location.reload();
                })
                .catch(function (error) {
                    console.log(error.response);
                    Swal.fire('Errore', error.response.message, 'error')
                });

        }
    })
}

function promptDisableAccount(user, row) {
    Swal.fire({
        title: 'Are you sure?',
        text: "You are going to disable the account!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, disable it!'
    }).then((result) => {
        if (result.value) {
            axios.post('disable-account', {
                    'user': user,
                }
            )
                .then(function (response) {
                    console.log(response);
                    row.remove().draw();

                    Swal.fire(
                        'Disabled!',
                        'The account has been deleted.',
                        'success'
                    );
                    // location.reload();
                })
                .catch(function (error) {
                    console.log(error);
                    Swal.fire('Errore', error.response, 'error')
                });

        }
    })
}

window.promptDeleteAccount = promptDeleteAccount;
window.promptDisableAccount = promptDisableAccount;


$(document).ready(function () {
    let table = $(".datatable").DataTable({
        responsive: true,
        order: [[0, "desc"]],
        language: {
            searchPlaceholder: 'Search...',
            sSearch: '',
            lengthMenu: '_MENU_ items per page',
        },
        paging: false,
        lengthChange: false,
        info: false,
        searching: false,
    });

    if ($(".page-requests").length) {
        // Homepage
        $("table.table-requests tbody")
            .on('click', 'a.approve-request', function (e) {
                e.preventDefault();
                let user = $(this).closest('tr[data-user-id]').data('user-id');
                $("input[name='user']").val(user);

                $("#approveRequestModal").modal();
            })
            .on('click', 'a.delete-account', function (e) {
                e.preventDefault();

                let tr = $(this).parents('tr');
                let user = tr.data('user-id');
                let row = table.row(tr);

                promptDeleteAccount(user, row);
            });

        $("#vendors-select").select2({
            width: '100%',
            placeholder: 'Choose one',
            searchInputPlaceholder: 'Search options',
            ajax: {
                url: '/vendors',

            },
        });

        $(".submit-request").click(function () {
            let vendor_number = $("#vendors-select").val();
            let user = $("input[name='user']").val();

            console.log('vendor', vendor_number, 'user', user);

            axios.post('enable-account', {
                    'user': user,
                    'vendor_number': vendor_number
                }
            )
                .then(function (response) {
                    Swal.fire('User approved!', '', 'success');
                    location.reload();
                })
                .catch(function (error) {
                    console.log(error.response);
                    Swal.fire('Errore', error.response.message, 'error')
                });
        });
    }

    if ($(".page-active-accounts").length) {

        $("table.active-accounts tbody")
            .on('click', '.disable-account', function (e) {
                e.preventDefault();

                let tr = $(this).parents('tr');
                let user = tr.data('user-id');
                let row = table.row(tr);

                promptDisableAccount(user, row);
            })
            .on('click', '.delete-account', function (e) {
                e.preventDefault();

                let tr = $(this).parents('tr');
                let user = tr.data('user-id');
                let row = table.row(tr);

                promptDeleteAccount(user, row);
            });
    }

    const markdown = $('#markdown-editor')
    if (markdown.length) {
        new SimpleMDE({
            element: markdown[0],
            spellChecker: false
        });
    }

    $("body").removeClass('preload')

    function deleteNews() {
        const id = $(this).attr('data-id')
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                axios.get(`news/${id}/delete`)
                    .then(function (response) {
                        Swal.fire(
                            'Deleted!',
                            'The news has been deleted.',
                            'success'
                        ).then(() => {
                            location.reload();
                        })
                    })
                    .catch(function (error) {
                        console.log(error.response);
                        Swal.fire('Errore', error.response.message, 'error')
                    });

            }
        })
    }
    $("table.table-news tbody").on('click','.delete-news', deleteNews)

    function deleteAttach() {
        const id = $(this).attr('data-id')
        const url = $(this).attr('data-url')
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                axios.get(`/news/${id}/remove-attached`, { params: { url } })
                    .then(function (response) {
                        Swal.fire(
                            'Deleted!',
                            'The file has been deleted.',
                            'success'
                        ).then(() => {
                            location.reload();
                        })
                    })
                    .catch(function (error) {
                        console.log(error.response);
                        Swal.fire('Errore', error.response.message, 'error')
                    });

            }
        })
    }
    $(".remove-news-attach").on('click', deleteAttach)
});
